module.exports = __webpack_public_path__ + "static/img/113_TO8_1636_og.bc4a5b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/113_TO8_1636_og.jpg
// module id = NRFz
// module chunks = 0